import script from "./WCCustomSelectModern.vue?vue&type=script&setup=true&lang=js"
export * from "./WCCustomSelectModern.vue?vue&type=script&setup=true&lang=js"

import "./WCCustomSelectModern.vue?vue&type=style&index=0&id=42be0a82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42be0a82"]])

export default __exports__